import { useQuery } from '@tanstack/react-query';

import axios from 'src/lib/axios';
import { QueryConfig } from 'src/lib/react-query';
import { ListDTO } from 'src/registry/types/queries';
import { formatResourcePath } from 'src/utils/regex';
import { ListResponseAPI } from 'src/lib/queries';
import { ReferenceRate } from 'src/features/referenceRates/utils/types';
import { CURRENCY } from 'src/types';

const RESOURCE = '/subscriptions/reference-rate/';

type QueryFnType = typeof queryFn;

interface DTO extends ListDTO {
    code?: string;
    currency?: CURRENCY;
    is_active?: boolean;
}

const queryFn = ({ ...params }: DTO): Promise<ListResponseAPI<ReferenceRate>> => {
    return axios.get(formatResourcePath(RESOURCE), { params });
};

interface UseQueryHookOptions extends DTO {
    config?: QueryConfig<QueryFnType>;
}
const useQueryHook = ({ config, ...payload }: UseQueryHookOptions) =>
    useQuery({
        queryKey: [RESOURCE, payload],
        queryFn: async () => await queryFn(payload),
        ...config,
    });

export { RESOURCE as LIST_REFERENCE_RATES_RESOURCE, useQueryHook as useListReferenceRates };
